"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comparedVehiclesReducer = void 0;
const object_utils_1 = require("../utils/object-utils");
const comparedVehicles_1 = require("../actions/comparedVehicles");
const initState = {};
const comparedVehiclesReducer = (compareVehicles = initState, action) => {
    switch (action.type) {
        case comparedVehicles_1.ADD_VEHICLES_TO_COMPARE:
            return (0, object_utils_1.deepCopy)(action.payload);
        case comparedVehicles_1.DELETE_COMPARE_VEHICLES:
            return initState;
        default:
            return compareVehicles;
    }
};
exports.comparedVehiclesReducer = comparedVehiclesReducer;
//# sourceMappingURL=comparedVehicles.reducer.js.map